import React from 'react';
import styled from 'styled-components';

const SizeChartStyled = styled.div`
  max-width: 1000px;
  width: 100%;
  margin: 2rem 0;
  padding: 2rem;
  background: var(--backgroundCard);
  border-radius: var(--borderRadius);
  box-shadow: var(--boxShadow);
  @media (max-width: 1023px) {
    width: auto;
    margin: 1rem;
    padding: 1rem;
  }
  .bc-size-chart,
  .table-wrapper {
    overflow-x: auto;
    white-space: nowrap;
  }
  .bc-size-chart {
    margin-inline: 2rem;
    p {
      white-space: normal;
    }
  }
  .table-wrapper > table,
  .table-wrapper > table th,
  .table-wrapper > table td {
    padding: 5px;
    font-size: 13px;
    border: 1px solid #eee !important;
    border-collapse: collapse;
    table-layout: auto;
  }
  .table-wrapper > table {
    margin-bottom: 5px;
    cursor: pointer;
  }
  .table-wrapper > table td {
    &:hover {
      background-color: var(--white);
    }
  }
  .table-wrapper > table th {
    text-align: center;
  }

  .table-wrapper > table th.fixed,
  .table-wrapper > table td.fixed {
    background: var(--greyLight);
    position: sticky;
    left: 0;
  }
  .table-wrapper > table tr:hover > td.fixed {
    background-color: var(--watermelon);
    color: var(--white);
  }
  .table-wrapper > table td {
    text-align: center;
  }
`;

export default function SizeChart() {
  return (
    <SizeChartStyled>
      <div className="bc-size-chart">
        <h4>Bont Rowing Size Chart</h4>
        <p>
          Hover over your current shoe size to get your Bont Rowing estimate.
        </p>
        <div className="table-wrapper">
          <table>
            <thead>
              <tr>
                <th className="fixed">
                  Bont Rowing
                  <br /> US / EU
                </th>
                <th>
                  Foot Length Range
                  <br />
                  (MM)
                </th>
                <th>
                  OMADA 2<br /> US Sizes
                </th>
                <th>
                  OMADA 2<br /> (MM)
                </th>
                <th>
                  OMADA 3<br /> US Sizes
                </th>
                <th>
                  OMADA 3<br /> (MM)
                </th>
                <th>
                  NEW WAVE
                  <br /> US Sizes
                </th>
                <th>
                  NEW WAVE
                  <br /> (MM)
                </th>
                <th>
                  H2ROW
                  <br /> US Sizes
                </th>
                <th>
                  H2ROW
                  <br /> (MM)
                </th>
                <th>
                  RUNNING SHOES
                  <br /> US Sizes Men (NIKE)
                </th>
                <th>
                  RUNNING SHOES
                  <br /> US Sizes Women (NIKE)
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="fixed">4 / 36</td>
                <td>216 - 220</td>
                <td>-</td>
                <td>-</td>
                <td>-</td>
                <td>-</td>
                <td>-</td>
                <td>-</td>
                <td>-</td>
                <td>-</td>
                <td>-</td>
                <td>-</td>
              </tr>
              <tr>
                <td className="fixed">4.5 / 37</td>
                <td>221 - 225</td>
                <td>-</td>
                <td>-</td>
                <td>-</td>
                <td>-</td>
                <td>-</td>
                <td>-</td>
                <td>-</td>
                <td>-</td>
                <td>-</td>
                <td>4</td>
              </tr>
              <tr>
                <td className="fixed">5 / 38</td>
                <td>226 - 230</td>
                <td>-</td>
                <td>-</td>
                <td>-</td>
                <td>-</td>
                <td>-</td>
                <td>-</td>
                <td>-</td>
                <td>-</td>
                <td>-</td>
                <td>5</td>
              </tr>
              <tr>
                <td className="fixed">6 / 39</td>
                <td>231 - 235</td>
                <td>-</td>
                <td>-</td>
                <td>6</td>
                <td>234</td>
                <td>-</td>
                <td>-</td>
                <td>6</td>
                <td>240</td>
                <td>-</td>
                <td>6</td>
              </tr>
              <tr>
                <td className="fixed">6.5 / 40</td>
                <td>236 - 240</td>
                <td>6</td>
                <td>237</td>
                <td>-</td>
                <td>-</td>
                <td>-</td>
                <td>-</td>
                <td>-</td>
                <td>-</td>
                <td>6</td>
                <td>7</td>
              </tr>
              <tr>
                <td className="fixed">7 / 40.5</td>
                <td>241 - 245</td>
                <td>7</td>
                <td>245</td>
                <td>7</td>
                <td>242</td>
                <td>-</td>
                <td>-</td>
                <td>-</td>
                <td>-</td>
                <td>7</td>
                <td>7.5</td>
              </tr>
              <tr>
                <td className="fixed">7.5 / 41</td>
                <td>246 - 250</td>
                <td>-</td>
                <td>-</td>
                <td>8</td>
                <td>250</td>
                <td>-</td>
                <td>-</td>
                <td>7</td>
                <td>250</td>
                <td>7.5</td>
                <td>8</td>
              </tr>
              <tr>
                <td className="fixed">8 / 42</td>
                <td>251 - 255</td>
                <td>8</td>
                <td>254</td>
                <td>9</td>
                <td>255</td>
                <td>-</td>
                <td>-</td>
                <td>-</td>
                <td>-</td>
                <td>8</td>
                <td>8.5</td>
              </tr>
              <tr>
                <td className="fixed">8.5 / 42.5</td>
                <td>256 - 260</td>
                <td>-</td>
                <td>-</td>
                <td>-</td>
                <td>-</td>
                <td>7</td>
                <td>260</td>
                <td>8</td>
                <td>260</td>
                <td>8.5</td>
                <td>9</td>
              </tr>
              <tr>
                <td className="fixed">9 / 43</td>
                <td>261 - 265</td>
                <td>9</td>
                <td>262</td>
                <td>-</td>
                <td>-</td>
                <td>-</td>
                <td>-</td>
                <td>-</td>
                <td>-</td>
                <td>9</td>
                <td>9.5</td>
              </tr>
              <tr>
                <td className="fixed">9.5 / 44</td>
                <td>266 - 270</td>
                <td>-</td>
                <td>-</td>
                <td>10</td>
                <td>268</td>
                <td>8</td>
                <td>268</td>
                <td>9</td>
                <td>270</td>
                <td>9.5</td>
                <td>10</td>
              </tr>
              <tr>
                <td className="fixed">10 / 44.5</td>
                <td>271 - 275</td>
                <td>10</td>
                <td>271</td>
                <td>11</td>
                <td>272</td>
                <td>-</td>
                <td>-</td>
                <td>-</td>
                <td>-</td>
                <td>10</td>
                <td>10.5</td>
              </tr>
              <tr>
                <td className="fixed">10.5 / 45</td>
                <td>276 - 280</td>
                <td>11</td>
                <td>279</td>
                <td>-</td>
                <td>-</td>
                <td>9</td>
                <td>276</td>
                <td>10</td>
                <td>280</td>
                <td>10.5</td>
                <td>11</td>
              </tr>
              <tr>
                <td className="fixed">11 / 46</td>
                <td>281 - 285</td>
                <td>-</td>
                <td>-</td>
                <td>12</td>
                <td>285</td>
                <td>10</td>
                <td>284</td>
                <td>-</td>
                <td>-</td>
                <td>11</td>
                <td>11.5</td>
              </tr>
              <tr>
                <td className="fixed">11.5 / 46.5</td>
                <td>286 - 290</td>
                <td>12</td>
                <td>288</td>
                <td>-</td>
                <td>-</td>
                <td>-</td>
                <td>-</td>
                <td>11</td>
                <td>290</td>
                <td>11.5</td>
                <td>12</td>
              </tr>
              <tr>
                <td className="fixed">12 / 47</td>
                <td>291 - 295</td>
                <td>-</td>
                <td>-</td>
                <td>13</td>
                <td>291</td>
                <td>11</td>
                <td>292</td>
                <td>-</td>
                <td>-</td>
                <td>12</td>
                <td>12.5</td>
              </tr>
              <tr>
                <td className="fixed">12.5 / 48</td>
                <td>296 - 300</td>
                <td>13</td>
                <td>296</td>
                <td>14</td>
                <td>300</td>
                <td>12</td>
                <td>300</td>
                <td>12</td>
                <td>300</td>
                <td>12.5</td>
                <td>13</td>
              </tr>
              <tr>
                <td className="fixed">13 / 49</td>
                <td>301 - 305</td>
                <td>14</td>
                <td>305</td>
                <td>-</td>
                <td>-</td>
                <td>-</td>
                <td>-</td>
                <td>-</td>
                <td>-</td>
                <td>13</td>
                <td>13.5</td>
              </tr>
              <tr>
                <td className="fixed">14 / 50</td>
                <td>306 - 310</td>
                <td>15</td>
                <td>313</td>
                <td>15 / 16</td>
                <td>307 / 313</td>
                <td>13 / 14</td>
                <td>308 / 315</td>
                <td>13</td>
                <td>310</td>
                <td>13.5 / 14</td>
                <td>14 / 15</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </SizeChartStyled>
  );
}
